import axios from "axios";
import http from "../api/client";
import { tl } from ".";

export default class VideoHelper {
    
    private static YoutubeRe =/((http|https):\/\/)?(www\.)?(youtube\.com|youtu\.be)(\/)?([a-zA-Z0-9\-\.]+)\/?/;

    private static YaDiskRe = /((http|https):\/\/)?(disk\.yandex\.ru)\/[id]\/([a-zA-Z0-9\-\.]+)\/?/;

    private static VimeoRe = /((http|https):\/\/)?(vimeo\.com)\/([a-zA-Z0-9\-\.]+)\/?/;

    private static VKRe = /((http|https):\/\/)?(vk\.com)\/([a-zA-Z0-9\-\.]+)/;

    private static RutubeRe = /((http|https):\/\/)?(rutube\.ru)\/([a-zA-Z0-9\-\.]+)/;
  
    static async getInfo(url: string): Promise<IVideoInfo | null> {
      if (VideoHelper.YoutubeRe.test(url)) {
        return await VideoHelper.getYoutubeInfo(url);
      }
      if (VideoHelper.VimeoRe.test(url)) {
        return await VideoHelper.getVimeoInfo(url);
      }
      if (VideoHelper.YaDiskRe.test(url)) {
        return await VideoHelper.getYaDiskInfo(url);
      }
    
      if (VideoHelper.VKRe.test(url)) {
        return await VideoHelper.getVideoInfo(url);
      }
      if (VideoHelper.RutubeRe.test(url)) {
        return await VideoHelper.getVideoInfo(url);
      }
      return null;
    }
  
    private static async getYaDiskInfo (url: string):Promise<IVideoInfo | null> {
      const response = await axios.get(
        `https://cloud-api.yandex.net/v1/disk/public/resources?public_key=${encodeURI(url)}`
      );
      const data = await response.data;
      return {
        url: url,
        preview: data.preview,
        name: data.name,
      };
    }

    private static async getVimeoInfo (url: string):Promise<IVideoInfo> {
      const response = await axios.get(
        `https://vimeo.com/api/oembed.json?url=${encodeURI(url)}`
      );
      const data = response.data
      return {
        url: url,
        preview: data.thumbnail_url,
        name: data.title,
      };
    }
  
    private static async getYoutubeInfo(url: string) :Promise<IVideoInfo | null> {
      const response = await axios.get(
        `https://youtube.com/oembed?url=${encodeURI(url)}&format=json`
      );
      const data = await response.data;
      return {
        url: url,
        preview: data.thumbnail_url,
        name: data.title,
      };
    }
  
    private static async getVideoInfo (url: string): Promise<IVideoInfo | null> {
      try {
        const response = await http.post(`/api/embed/video`, {
          link: encodeURI(url)
        });
        const data = await response.data;
        return {
          url: url,
          preview: data.thumbnail_url,
          name: data.title,
        };
      } catch {
        return {
          url,
          name: tl('Видео'),
          preview: '/public/images/_anti/protected-video.png',
        };
      }
    }
  }
  
  export interface IVideoInfo {
    name: string;
    preview: string;
    url: string;
  }
  